module.exports = __webpack_public_path__ + "img/hr-deepwater-green1.e6d38077.png";